<template>
  <ion-split-pane content-id="admin-content" when="md">
    <!-- Sidebar Menu -->
    <ion-menu content-id="admin-content" menu-id="admin-menu">
      <ion-header class="ion-no-border">
        <ion-toolbar class="sidebar-header">
          <div class="sidebar-logo">
            <img src="/assets/icon/logo_desa.svg" alt="Logo Desa" />
            <div>
              <h3>Admin Panel</h3>
              <p>Desa Cinto Mandi</p>
            </div>
          </div>
        </ion-toolbar>
      </ion-header>
      
      <ion-content class="sidebar-content">
        <ion-list lines="none" class="sidebar-list">
          <!-- Dashboard -->
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/dashboard" router-direction="root" :class="{ 'selected-item': isActive('/admin/dashboard') }">
              <ion-icon :icon="homeOutline" slot="start"></ion-icon>
              <ion-label>Dashboard</ion-label>
            </ion-item>
          </ion-menu-toggle>
          
          <!-- Laporan Kehadiran -->
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/laporankehadiran" router-direction="root" :class="{ 'selected-item': isActive('/admin/laporankehadiran') }">
              <ion-icon :icon="documentTextOutline" slot="start"></ion-icon>
              <ion-label>Rekap Absensi</ion-label>
            </ion-item>
          </ion-menu-toggle>
          
          <!-- Data Pegawai -->
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/halamanpengguna" router-direction="root" :class="{ 'selected-item': isActive('/admin/halamanpengguna') }">
              <ion-icon :icon="peopleOutline" slot="start"></ion-icon>
              <ion-label>Data Pegawai</ion-label>
            </ion-item>
          </ion-menu-toggle>
          
          <!-- Laporan Izin (Hidden per user request) -->
          <!--
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/laporanizin" router-direction="root" :class="{ 'selected-item': isActive('/admin/laporanizin') }">
              <ion-icon :icon="mailUnreadOutline" slot="start"></ion-icon>
              <ion-label>Laporan Izin</ion-label>
            </ion-item>
          </ion-menu-toggle>
          -->
          
          <!-- Laporan Gaji (Hidden per user request) -->
          <!--
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/laporangaji" router-direction="root" :class="{ 'selected-item': isActive('/admin/laporangaji') }">
              <ion-icon :icon="walletOutline" slot="start"></ion-icon>
              <ion-label>Laporan Gaji</ion-label>
            </ion-item>
          </ion-menu-toggle>
          -->
          
          <!-- Approval (Hidden per user request) -->
          <!--
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/approval/halamanapproval" router-direction="root" :class="{ 'selected-item': isActive('/approval/halamanapproval') }">
              <ion-icon :icon="checkmarkCircleOutline" slot="start"></ion-icon>
              <ion-label>Approval</ion-label>
            </ion-item>
          </ion-menu-toggle>
          -->

          <!-- Setting (Hidden per user request) -->
          <!--
          <ion-menu-toggle auto-hide="false">
            <ion-item router-link="/admin/halamansetting" router-direction="root" :class="{ 'selected-item': isActive('/admin/halamansetting') }">
              <ion-icon :icon="settingsOutline" slot="start"></ion-icon>
              <ion-label>Pengaturan</ion-label>
            </ion-item>
          </ion-menu-toggle>
          -->
        </ion-list>
      </ion-content>

      <ion-footer class="ion-no-border">
        <ion-toolbar class="sidebar-footer">
          <ion-menu-toggle auto-hide="false">
            <ion-item button @click="logOut" class="logout-btn" lines="none">
              <ion-icon :icon="logOutOutline" slot="start" color="danger"></ion-icon>
              <ion-label color="danger">Logout</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-toolbar>
      </ion-footer>
    </ion-menu>

    <!-- Main Content Area -->
    <ion-router-outlet id="admin-content"></ion-router-outlet>
  </ion-split-pane>
</template>

<script setup>
import { 
  IonSplitPane, IonMenu, IonHeader, IonToolbar, IonContent, 
  IonList, IonItem, IonIcon, IonLabel, IonMenuToggle, 
  IonRouterOutlet, IonFooter, alertController 
} from '@ionic/vue';
import { 
  homeOutline, documentTextOutline, peopleOutline, 
  logOutOutline
} from 'ionicons/icons';
import { useRoute, useRouter } from 'vue-router';
import { getAuth, signOut } from "firebase/auth";

const route = useRoute();
const router = useRouter();
const auth = getAuth();

const isActive = (path) => {
  return route.path === path || route.path.startsWith(path + '/');
};

const logOut = async () => {
  const alert = await alertController.create({
    header: "Konfirmasi Logout",
    mode: "ios",
    message: "Apakah Anda yakin ingin keluar?",
    buttons: [
      {
        text: "Batal",
        role: "cancel",
      },
      {
        text: "Logout",
        role: "destructive",
        handler: async () => {
          try {
            await signOut(auth);
            localStorage.clear();
            sessionStorage.clear();
            router.push({ name: "login" }).then(() => {
              router.go(0);
            });
          } catch (error) {
            console.error("Logout error", error);
          }
        },
      },
    ],
  });
  await alert.present();
};
</script>

<style scoped>
.sidebar-header {
  --background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%);
  padding: 24px 16px;
  border-bottom: none;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 16px;
}

.sidebar-logo img {
  width: 54px;
  height: 54px;
  background: white;
  border-radius: 14px;
  padding: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.sidebar-logo h3 {
  color: #1d4ed8; /* Light Blue / Sky */
  font-size: 1.15rem;
  font-weight: 800;
  margin: 0 0 4px 0;
  letter-spacing: 0.3px;
}

.sidebar-logo p {
  color: #1d4ed8; /* Lighter Blue */
  font-size: 0.85rem;
  margin: 0;
  font-weight: 700;
}

.sidebar-content {
  --background: #ffffff;
}

.sidebar-list {
  background: transparent;
  padding: 16px 12px;
}

.sidebar-list ion-item {
  --background: transparent;
  --border-radius: 12px;
  margin-bottom: 6px;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  --min-height: 50px;
  transition: all 0.2s ease;
}

.sidebar-list ion-item::part(native) {
  padding-left: 12px;
}

.sidebar-list ion-item:hover {
  --background: #f1f5f9;
}

.sidebar-list ion-item ion-icon {
  color: #64748b;
  font-size: 1.4rem;
  margin-right: 16px;
}

.sidebar-list ion-item.selected-item {
  --background: #eff6ff;
  color: #1d4ed8;
  position: relative;
}

.sidebar-list ion-item.selected-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10%;
  height: 80%;
  width: 4px;
  background: #2563eb;
  border-radius: 0 4px 4px 0;
  z-index: 2;
}

.sidebar-list ion-item.selected-item ion-icon {
  color: #2563eb;
}

.sidebar-footer {
  --background: #f8fafc;
  padding: 16px;
  border-top: 1px solid #e2e8f0;
}

.logout-btn {
  --background: #fef2f2;
  --border-radius: 12px;
  font-weight: 700;
  color: #ef4444;
  --padding-start: 16px;
}

.logout-btn ion-icon {
  color: #ef4444;
}

.logout-btn:hover {
  --background: #fee2e2;
}
</style>
